export default __webpack_public_path__ + "static/media/268.bac87476.png";